export const locationsKeys = {
  all: ['locations'],
};
